import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useEffect, useState } from "react";

enum SortingStates {
  Alphabetical = "Alphabetical",
  LowToHigh = "Low to High",
  HighToLow = "High to Low",
}

interface ScoreSortSelectProps {
  setSortingValue: React.Dispatch<React.SetStateAction<0 | 1 | 2>>;
};

const ScoreSortSelect: React.FC<ScoreSortSelectProps> = ({ setSortingValue }) => {
  const [value, setValue] = useState<string>(SortingStates.Alphabetical);

  const STORAGE_KEY = "scoreSortMode";

  useEffect(() => {
    try {
      // Initialize from localStorage on mount
      const stored = localStorage.getItem(STORAGE_KEY) as string | null;
      switch (stored) {
        case SortingStates.HighToLow:
          setValue(SortingStates.HighToLow);
          setSortingValue(1);
          break;
        case SortingStates.LowToHigh:
          setValue(SortingStates.LowToHigh);
          setSortingValue(2);
          break;
        case SortingStates.Alphabetical:
          setValue(SortingStates.Alphabetical);
          setSortingValue(0);
          break;
        default:
          break;
      }
    } catch (e) {
    }
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    switch (event.target.value) {
      case SortingStates.HighToLow: {
        setValue(SortingStates.HighToLow);
        setSortingValue(1);
        try { localStorage.setItem(STORAGE_KEY, SortingStates.HighToLow); } catch { }
        break;
      }
      case SortingStates.LowToHigh: {
        setValue(SortingStates.LowToHigh);
        setSortingValue(2);
        try { localStorage.setItem(STORAGE_KEY, SortingStates.LowToHigh); } catch { }
        break;
      }
      default: {
        setValue(SortingStates.Alphabetical);
        setSortingValue(0);
        try { localStorage.setItem(STORAGE_KEY, SortingStates.Alphabetical); } catch { }
        break;
      }
    }
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="selected-sort-mode">Sort Mode</InputLabel>
      <Select
        labelId="selected-sort-mode"
        label="Sort Mode"
        id="sort-mode-select"
        value={value}
        onChange={handleChange}
      >
        <MenuItem value={SortingStates.Alphabetical}>{SortingStates.Alphabetical}</MenuItem>
        <MenuItem value={SortingStates.HighToLow}>{SortingStates.HighToLow}</MenuItem>
        <MenuItem value={SortingStates.LowToHigh}>{SortingStates.LowToHigh}</MenuItem>
      </Select>
    </FormControl>
  );
}

export default ScoreSortSelect;
